import Modal from '../modules/Modal';
import MigrateVToken, { Props } from '../views/MigrateVToken';

export type { Props as MigrateVTokenModalProps };

const MigrateVTokenModal = (props: Props) => {
  return (
    <Modal size="2xl" clickOffToClose>
      <div className="pt-8 pb-4 px-6 bg-gray-50">
        <MigrateVToken {...props} />
      </div>
    </Modal>
  );
};

export default MigrateVTokenModal;
